import { render, staticRenderFns } from "./EditDetailsBtn.vue?vue&type=template&id=ef7d154a&scoped=true&"
import script from "./EditDetailsBtn.vue?vue&type=script&lang=ts&"
export * from "./EditDetailsBtn.vue?vue&type=script&lang=ts&"
import style0 from "./EditDetailsBtn.vue?vue&type=style&index=0&id=ef7d154a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d154a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
